// @flow
import React, { Fragment } from 'react';
import styled from 'styled-components';
import { finectAPI } from '@finect/front-utils/finectAPI';
import { slugify } from '@finect/front-utils/slugify';
import { grid } from '@finect/tabular-utils/grid';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { Button } from '@finect/tabular-core/Button';
import { SectionTitle, NewSectionInner } from '../';
import { TopAnswers } from './partials';
import { Question } from './Question';

const CTA = styled.div`
  padding: 0 30px 30px;
  text-align: center;

  ${maxMediaQueries.miniDesktop`
    padding: 0 24px 24px;
  `};

  ${maxMediaQueries.phone`
    padding: 0 15px 15px;
  `};
`;

type Props = {
  staticContext?: Object
};

type State = {
  questions: Array<{
    id: string,
    author: string,
    title: string,
    tags: Array<{
      id: number,
      name: string,
      description: string,
      is_followed: boolean
    }>,
    answers: Array<{
      id: number,
      author: string
    }>,
    authors: {
      [key: string]: {
        id: string,
        type: string,
        subtype?: string,
        alias: string,
        name?: string,
        first_name?: string,
        last_name?: string,
        icon_url: string,
        url: string,
        certification?: Object,
        adviser_at?: {
          company_name: string,
          company_icon_url: string,
          company_url: string
        },
        stats?: Object
      }
    }
  }>
};

export class TopQuestions extends React.Component<Props, State> {
  state =
    typeof window === 'undefined'
      ? { questions: (this.props.staticContext && this.props.staticContext.initialData.topQuestions) || [] }
      : { questions: (window.initialData && window.initialData.topQuestions) || [] };

  componentDidMount() {
    if (!this.state.questions.length) {
      TopQuestions.loadInitialData().then(topQuestions => this.setState({ questions: topQuestions || [] }));
    }
  }

  static loadInitialData(cookie?: string) {
    return finectAPI({
      version: 'v3',
      path: 'questions/advisers',
      method: 'GET',
      credentials: cookie,
      onSuccess: (topQuestions: Object) => topQuestions,
      onError: (err) => console.log(err, 'Request to questions/advisers failed!'), // eslint-disable-line
    });
  }

  render() {
    const { questions } = this.state;
    const baseURL = `https://${process.env.FINECT_BASEURL || 'www.finect.com'}`;

    return (
      <Fragment>
        <NewSectionInner textAlign="center">
          <SectionTitle
            title="Asesores financieros que responden tus preguntas"
            subtitle="Un asesor financiero puede ayudarte a resolver cualquier duda financiera en nuestra sección de preguntas."
          />
        </NewSectionInner>
        <TopAnswers>
          {questions.map((question, index) => {
            const {
              first_name: firstName,
              last_name: lastName,
              name,
              subtype,
              icon_url: icon,
              adviser_at: adviserAt
            } = question.authors[question.answers[0].author];
            const author = question.authors[question.author];
            const displayName = firstName ? `${firstName}${lastName ? ` ${lastName}` : ''}` : '';
            const adviser = {
              name: displayName || name || '',
              icon,
              subtype,
              company: adviserAt
                ? {
                  name: adviserAt.company_name,
                  icon: adviserAt.company_icon_url
                }
                : null
            };
            return (
              <Question
                key={`${question.id}${index}`}
                question={question.title}
                author={author.first_name === author.alias ? `@${author.alias}` : author.first_name}
                adviser={adviser}
                url={`${baseURL}/preguntas/${question.id}/${slugify(question.title)}#respuesta-${
                  question.answers[0].id
                }`}
              />
            );
          })}
        </TopAnswers>
        <CTA>
          <Button
            data-fi-event="home-asesores"
            as="a"
            width={`${grid(3)}px`}
            href={`${baseURL}/preguntas/nueva-pregunta`}
            secondary
            rel="nofollow"
          >
            Escribe tu pregunta
          </Button>
        </CTA>
      </Fragment>
    );
  }
}
